/**
 * Configuration Validator
 * Validates SDK configuration parameters
 */

import { ValidationError } from '../errors/VoiceMateErrors.js';

export class Validator {
  /**
   * Validate SDK configuration
   * @param {Object} config - Configuration object
   * @throws {ValidationError} If configuration is invalid
   */
  static validateConfig(config) {
    // Required fields
    if (!config.serverUrl) {
      throw new ValidationError('serverUrl is required', {
        field: 'serverUrl',
        value: config.serverUrl
      });
    }

    if (!config.botNumber) {
      throw new ValidationError('botNumber is required', {
        field: 'botNumber',
        value: config.botNumber
      });
    }

    // URL format validation
    try {
      new URL(config.serverUrl);
    } catch (e) {
      throw new ValidationError('serverUrl must be a valid URL', {
        field: 'serverUrl',
        value: config.serverUrl,
        error: e.message
      });
    }

    // Numeric constraints
    if (config.audio?.volume !== undefined) {
      if (typeof config.audio.volume !== 'number' || config.audio.volume < 0 || config.audio.volume > 2) {
        throw new ValidationError('audio.volume must be a number between 0 and 2', {
          field: 'audio.volume',
          value: config.audio.volume
        });
      }
    }

    if (config.maxReconnectAttempts !== undefined) {
      if (typeof config.maxReconnectAttempts !== 'number' || config.maxReconnectAttempts < 0) {
        throw new ValidationError('maxReconnectAttempts must be a non-negative number', {
          field: 'maxReconnectAttempts',
          value: config.maxReconnectAttempts
        });
      }
    }

    if (config.reconnectDelay !== undefined) {
      if (typeof config.reconnectDelay !== 'number' || config.reconnectDelay < 0) {
        throw new ValidationError('reconnectDelay must be a non-negative number', {
          field: 'reconnectDelay',
          value: config.reconnectDelay
        });
      }
    }

    // Valid log levels
    const validLogLevels = ['debug', 'info', 'warn', 'error', 'silent'];
    if (config.logLevel && !validLogLevels.includes(config.logLevel)) {
      throw new ValidationError(`logLevel must be one of: ${validLogLevels.join(', ')}`, {
        field: 'logLevel',
        value: config.logLevel,
        validValues: validLogLevels
      });
    }

    return true;
  }
}
